export default __webpack_public_path__ + "static/media/freezers.53ad4f2f.png";